import $ from 'jquery';

export default () => {
    const gallery = $('.js-gallery-slider');
    const thumbs = $('.js-gallery-thumbs');

    if (gallery.is('*')) {
        gallery.slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true,
            asNavFor: '.js-gallery-thumbs'
        });
        thumbs.slick({
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: false,
            asNavFor: '.js-gallery-slider',
            focusOnSelect: true,
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 900,
                    settings: {
                        slidesToShow: 5
                    }
                }
            ]
        });
    }
}
